import { useQuery } from '@tanstack/react-query'
import { fetchServices } from '../api/services'

const FALLBACK_SERVICES = [
  {
    id: 1,
    title:       'Balloon Decoration',
    description: 'From simple balloon clusters to elaborate arches, columns, and sculptures — every party deserves a spectacular balloon setup that sets the mood the moment guests walk in.',
    icon:        '🎈',
    color:       '#FF6BB5',
  },
  {
    id: 2,
    title:       'Character Costumes',
    description: 'Beloved characters come to life at your party! Disney princesses, superheroes, cartoon favorites — our fully costumed, interactive performers create unforgettable moments for every child.',
    icon:        '🦸',
    color:       '#7C3AFF',
  },
  {
    id: 3,
    title:       'Theme Decoration',
    description: 'Full venue transformation tailored to your chosen theme — from table settings and centrepieces to backdrops and ceiling décor. Every detail is planned and executed with love.',
    icon:        '✨',
    color:       '#FFC300',
  },
  {
    id: 4,
    title:       'DJ & Music',
    description: "High-energy DJ sets, children's favourite songs, and interactive dance games that keep the energy alive from the first guest's arrival to the very last dance.",
    icon:        '🎵',
    color:       '#22C55E',
  },
  {
    id: 5,
    title:       'Photography',
    description: 'Professional photographers on-site to capture every magical moment — candid laughs, cake cutting, character hugs. Memories your family will treasure and smile about for years.',
    icon:        '📸',
    color:       '#F97316',
  },
  {
    id: 6,
    title:       'Birthday Cakes',
    description: 'Custom-designed birthday cakes crafted to perfectly match your chosen theme — beautiful, delicious, and completely Instagram-worthy. Mini cupcakes and dessert tables also available.',
    icon:        '🎂',
    color:       '#EC4899',
  },
]

export function useServices() {
  const query = useQuery({
    queryKey: ['services'],
    queryFn: fetchServices,
    staleTime: 10 * 60 * 1000,
    retry: 1,
    placeholderData: FALLBACK_SERVICES,
  })

  return {
    ...query,
    data: query.data ?? FALLBACK_SERVICES,
  }
}

export { FALLBACK_SERVICES }
